import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppSpinnerService } from './app-spinner.service';

@Component({
    selector: 'app-spinner',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (visible()) {
            <div class="app-spinner-overlay" role="status" aria-live="polite">
                <span class="app-spinner-ring"></span>
            </div>
        }
    `,
    styles: [`
        :host { contain: layout style; }
        .app-spinner-overlay {
            position: fixed;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.35);
            z-index: 9000;
            pointer-events: auto;
        }
        .app-spinner-ring {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            border-top: 4px solid var(--highlight_primary);
            border-right: 4px solid transparent;
            animation: app-spinner-rotation 1s linear infinite;
            position: relative;
        }
        .app-spinner-ring::after {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 50%;
            box-sizing: border-box;
            border-bottom: 4px solid var(--highlight_secondary);
            border-left: 4px solid transparent;
        }
        @keyframes app-spinner-rotation {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }
    `],
})
export class AppSpinnerComponent {
    private readonly service = inject(AppSpinnerService);
    readonly visible = this.service.visible;
}
